// Passage CRUD action types
export const CREATE_PASSAGE_REQUEST = 'CREATE_PASSAGE_REQUEST';
export const CREATE_PASSAGE_SUCCESS = 'CREATE_PASSAGE_SUCCESS';
export const CREATE_PASSAGE_FAILURE = 'CREATE_PASSAGE_FAILURE';

export const FETCH_PASSAGES_REQUEST = 'FETCH_PASSAGES_REQUEST';
export const FETCH_PASSAGES_SUCCESS = 'FETCH_PASSAGES_SUCCESS';
export const FETCH_PASSAGES_FAILURE = 'FETCH_PASSAGES_FAILURE';

export const UPDATE_PASSAGE_REQUEST = 'UPDATE_PASSAGE_REQUEST';
export const UPDATE_PASSAGE_SUCCESS = 'UPDATE_PASSAGE_SUCCESS';
export const UPDATE_PASSAGE_FAILURE = 'UPDATE_PASSAGE_FAILURE';

export const DELETE_PASSAGE_REQUEST = 'DELETE_PASSAGE_REQUEST';
export const DELETE_PASSAGE_SUCCESS = 'DELETE_PASSAGE_SUCCESS';
export const DELETE_PASSAGE_FAILURE = 'DELETE_PASSAGE_FAILURE';
